import { FormInstance } from "antd";
import { createContext } from "react";

const EditableContext = createContext<FormInstance<any> | null>(null);

export default EditableContext;